"use client";

import React, { useState } from "react";
import Link from "next/link";
import { getSession, signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import GoogleTerms from "./register/GoogleTerms";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const router = useRouter();

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setMessage("Signing in... Please wait.");

    const errMsg =
      "Something went wrong. Please ensure your email and password are correct.";

    try {
      const result = await signIn("credentials", {
        redirect: false,
        email,
        password,
      });

      if (!result || result.error) setMessage(errMsg);
      else if (result.ok) {
        try {
          setMessage("Login successful!");
          const session = await getSession();
          if (session?.user?.id)
            router.push(`/user/${session.user.id}/profile/edit`);
          else
            setMessage(
              "Something went wrong. Refresh your browser and try again."
            );
        } catch (err) {
          setMessage(
            "Something went wrong. Refresh your browser and try again."
          );
        }
      } else setMessage("Login failed. Please try again.");
    } catch (error) {
      console.log(error.message, error.response);
      setMessage(errMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  // useEffect(() => {
  //   sessionUser && handleSignOut();
  // }, [sessionUser]);

  return (
    <div>
      <form
        onSubmit={handleEmailSignIn}
        className="flex flex-col gap-[10px] items-center"
      >
        <div>
          <label className="md:text-[16px] text-[12px]">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex text-center gap-[10px] justify-center w-[247px] md:w-[483px] h-[35px] md:h-[43px] border-[1px] border-[#000] rounded-[30px] outline-none"
            required
          />
        </div>
        <div>
          <label className="md:text-[16px] text-[12px]">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="flex text-center gap-[10px] justify-center w-[247px] md:w-[483px] h-[35px] md:h-[43px] border-[1px] border-[#000] rounded-[30px] md:mb-[20px] mb-[10px] outline-none"
            required
          />
        </div>
        <button
          type="submit"
          className="flex items-center gap-[10px] justify-center w-[247px] md:w-[483px] h-[35px] md:h-[43px] outline-none border-[#000] rounded-[30px] bg-[#FFBF00]"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Signing in..." : "Login"}
        </button>
        {message && (
          <div
            className={`mt-4 text-center ${
              message.includes("successful") ? "text-green-600" : "text-red-600"
            }`}
          >
            {message}
          </div>
        )}
        <ul className="flex items-center justify-between w-[247px] md:w-[483px] text-[10px] font-bold">
          <li>
            <span>New User?</span>{" "}
            <Link
              href="/auth/register/register-email"
              className="text-[#FFBF00]"
            >
              Sign Up here
            </Link>
          </li>
          <li>
            <Link href="/auth/register/forget-password">Forget Password?</Link>
          </li>
        </ul>
        <GoogleTerms />
      </form>
    </div>
  );
}
